import axios from 'axios';
import authHeader from '../auth-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getMitraPelatihan = 'mitra-pelatihan';
const postMitraPelatihanUrl = 'mitra-pelatihan';
const putMitraPelatihan = 'mitra-pelatihan/';
const deleteMitraPelatihan = 'mitra-pelatihan/';

class MitraPelatihanService {
    getMitraPelatihan(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getMitraPelatihan + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter,
            {
                headers: authHeader()
            });
    }

    postMitraPelatihan(formData) {  
        var form = new FormData();
        form.append('namaMitraPelatihan',formData.namaMitraPelatihan);    

        if (typeof formData.logoMitraPelatihan !== 'undefined') {
            form.append('logoMitraPelatihan', formData.logoMitraPelatihan);
        }

        if (typeof formData.tandaTanganMitraPelatihan !== 'undefined') {
            form.append('tandaTanganMitraPelatihan', formData.tandaTanganMitraPelatihan);
        }
        
        form.append('status',formData.status);
        return axios
        .post(
            API_URL + postMitraPelatihanUrl, form ,
            { headers: authHeader() }
        );
    }

    putMitraPelatihan(formData) {
        var headers = authHeader(); 
        var form = new FormData();
        form.append('namaMitraPelatihan',formData.namaMitraPelatihan);
        
        if (typeof formData.logoMitraPelatihan !== 'undefined') {
            form.append('logoMitraPelatihan', formData.logoMitraPelatihan);
        }

        if (typeof formData.tandaTanganMitraPelatihan !== 'undefined') {
            form.append('tandaTanganMitraPelatihan', formData.tandaTanganMitraPelatihan);
        }

        form.append('idMitraPelatihan', formData.idMitraPelatihan);
     
        
        form.append('status',formData.status);

        return axios
        .put(
            API_URL + putMitraPelatihan + formData.idMitraPelatihan, form,
            { headers: authHeader() }
        );
    }

    deleteMitraPelatihan(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteMitraPelatihan + formData.idMitraPelatihan,
                { headers: authHeader() }
            );
    }

}

export default new MitraPelatihanService();